import { useEffect, useState } from "react";
import { fetchCurrencyWallet } from "./api-handler";
import HexLoader from "../../HexLoader";
import RadioListing from "../../RadioListing";
import { getLabel } from "../../../hooks/use-labels";
import { formatCurrency } from "../../../utils/common-utils";

import LabelItem from "../components/LabelItem";
import WalletImage from "../assets/wallet.svg";

const WalletProcessor = (props) => {
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);

  const { methodDetails, onChange } = props;

  useEffect(() => {
    fetchCurrencyWallet(props.currency).then(({ data }) => {
      setWallet(data);
      setLoading(false);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <HexLoader />;

  if (!wallet) return null;

  const onChangeOption = ({ target }) => {
    const walletInfo = {
      walletId: target.value,
      amount: props.amount,
      description: props.description,
      purpose: props.purpose,
    };

    onChange({ ...walletInfo, method: "WALLET" });
  };

  return (
    <div className="wallet-processor">
      <RadioListing
        options={[
          {
            label: (
              <LabelItem
                title={getLabel("walletTitle")}
                subTitle={formatCurrency(
                  wallet.currentBalance,
                  wallet.currencyCode
                )}
              />
            ),
            value: wallet.id,
            imgSrc: WalletImage,
            disabled: !wallet.currentBalance,
          },
        ]}
        className="payment-radio-listing"
        value={methodDetails.walletId}
        onChange={onChangeOption}
        labelClass={"align-start"}
      />
    </div>
  );
};

export default WalletProcessor;
